import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const CreatorWelcome = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const verifyPayment = async () => {
      const sessionId = searchParams.get('session_id');

      if (!sessionId) {
        setStatus('error');
        setErrorMessage('No payment session found. Please try again.');
        return;
      }

      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/verify-creator-payment?session_id=${sessionId}`
        );
        const data = await response.json();

        if (data.success) {
          setStatus('success');
          // Auto-redirect to creator info page after 3 seconds
          setTimeout(() => navigate('/creator-info'), 3000);
        } else {
          setStatus('error');
          setErrorMessage(data.error || 'Payment verification failed. Please contact support.');
        }
      } catch (error) {
        console.error('Error verifying payment:', error);
        setStatus('error');
        setErrorMessage('Unable to verify payment. Please contact support.');
      }
    };

    verifyPayment();
  }, [searchParams, navigate]);

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 10000
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '10px',
        textAlign: 'center',
        maxWidth: '400px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
      }}>
        {status === 'loading' && (
          <>
            <div style={{
              fontSize: '48px',
              marginBottom: '20px',
              animation: 'spin 1s linear infinite'
            }}>
              ⏳
            </div>
            <h2 style={{
              marginBottom: '15px',
              color: '#333'
            }}>
              Verifying Payment...
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#666'
            }}>
              Please wait while we confirm your payment.
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{
              fontSize: '48px',
              marginBottom: '20px'
            }}>
              ✅
            </div>
            <h2 style={{
              marginBottom: '15px',
              color: '#333'
            }}>
              Payment Successful!
            </h2>
            <p style={{
              fontSize: '18px',
              color: '#666',
              marginBottom: '20px'
            }}>
              Complete your creator profile to start submitting routes!
            </p>
            <button
              onClick={() => navigate('/creator-info')}
              style={{
                padding: '10px 20px',
                backgroundColor: '#FFD700',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: 'bold'
              }}
            >
              OK
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{
              fontSize: '48px',
              marginBottom: '20px'
            }}>
              ❌
            </div>
            <h2 style={{
              marginBottom: '15px',
              color: '#333'
            }}>
              Payment Verification Failed
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#666',
              marginBottom: '10px'
            }}>
              {errorMessage}
            </p>
            <p style={{
              fontSize: '14px',
              color: '#888',
              marginBottom: '20px'
            }}>
              Please contact us at <a href="mailto:matthew@backpass.co" style={{ color: '#667eea' }}>matthew@backpass.co</a> with this issue and we'll help you right away.
            </p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button
                onClick={() => navigate('/creator-special/gemma')}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#667eea',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: 'bold'
                }}
              >
                Try Again
              </button>
              <button
                onClick={() => navigate('/')}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#f0f0f0',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '16px'
                }}
              >
                Go Home
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CreatorWelcome;